// @returns event handle list which you can unbind later passing to: google.maps.event.removeListener(handle);
function listener(listenerTypeMap, libMap, target, events) {
    return Odigeo._.reduce(events, function(handleList, cbk, eventNamespace) {
        const eventName = eventNamespace.split('.')[0];

        handleList[eventNamespace] = libMap.event[listenerTypeMap](target, eventName, Odigeo._.partial(cbk, _, target));
        return handleList;
    }, {});
}

function hasMouseAction(evt) {
    return Odigeo._.isObject(evt) && (evt instanceof window.MouseEvent || evt.originalEvent instanceof window.MouseEvent);
}

function getListeners(libMap) {
    return {
        rebindListeners(target, events) {
            listener('clearListeners', libMap, target, events);
            return listener('addListener', libMap, target, events);
        },
        listenTo(target, events) {
            return listener('addListener', libMap, target, events);
        },
        listenToOnce(target, events) {
            return listener('addListenerOnce', libMap, target, events);
        },
        listenToDom(target, events) {
            return listener('addDomListener', libMap, target, events);
        },
        removeListener(listener) {
            libMap.event.removeListener(listener);
        },
    };
}

module.exports = {
    getListeners,
    hasMouseAction,
};
